<template>
  <div style="padding: 0;" v-if="profile">
    <!-- HEAD BOTTOM PART2 - SMALL SCREEN -->
    <div class="row hidden-sm hidden-md hidden-lg head__bottom--mobile m-n">
      <div class="headerLocation padding-sm">
        <span class="head_fonts profile-name">{{ publicName }}</span>
        <small v-if="profile.city || profile.country_id" class="block head_small_fonts">
          <i class="fa fa-map-marker icon"></i>
          <span v-if="profile.city">{{ profile.city }}</span>
          <span class="text-u-c">{{ getCountryName(profile.country_id) }}</span>
        </small>
      </div>
    </div>
    <div ref="companyHeader" class="row m-n">
      <div class="col-md-12 p-t-n p-l-n hidden-xs">
        <div class="headerLocation">
          <span class="head_fonts profile-name">{{ publicName }}</span>
          <small v-if="profile.city || profile.country_id" class="head_small_fonts">
            <i class="fa fa-map-marker icon"></i>
            <span v-if="profile.city">{{ profile.city }}</span>
            <span class="text-u-c p-l-sm">{{ getCountryName(profile.country_id) }}</span>
          </small>
        </div>
      </div>
      <div class="col-md-2 col-sm-3 hidden-xs no-padder head__navbar">
        <div class="m-t">
          <user-nav></user-nav>
        </div>
        <!-- MARKETPLACE -->
        <div v-if="isShopAvailable()" class="nfooter text-center m-a m-b-lg">
          <a style="cursor: pointer;" :href="marketplaceUrl" target="_blank">
            <button class="btn btn-danger nfooter__font hidden-xs">SHOP from here</button>
          </a>
        </div>
      </div>
      <div class="col-md-10 col-sm-9 col-xs-12 no-padder head">
        <section class="panel panel-default m-b-n no-border">
          <div ref="coverImage" class="panel-body no-padder head__body">
            <div v-if="!isCoverImage" class="preloader"></div>
            <div
              v-if="industryName"
              class="wrapper-xs text-u-c text-sm font-bold head__body__industry padder"
            >{{ industryName }}</div>
            <!-- AVATAR -->
            <div class="head__body__avatar">
              <div class="b b-white bg-white inline box-shadow m-t-xs">
                <div class="imgSize img-full avatar-img profile-avatar text-center">
                  <lazy-img-loader
                    :mainImg="profile.public_picture"
                    :imgAlt="profile.public_identity"
                    :imgWidth="128"
                    :imgHeight="128"
                  ></lazy-img-loader>
                </div>
              </div>
            </div>
            <!-- FOOTER1 -->
            <div class="b-light hidden-xs head__body__bottom bg-darker">
              <div class="info" style="border: 1px solid transparent; float: left !important;">
                <div></div>
                <div class="item m-l-md">
                  <span class="profileActiveCount">{{followersCount}}</span>
                  <small class="block m-t-n-xs">
                    <span>followers</span>
                  </small>
                </div>
                <div class="item">
                  <span class="profileActiveCount">{{articlesCount}}</span>
                  <small class="block m-t-n-xs">
                    <span>articles</span>
                  </small>
                </div>
                <div class="item">
                  <span class="profileActiveCount">{{eventsCount}}</span>
                  <small class="block m-t-n-xs">
                    <span>events</span>
                  </small>
                </div>
              </div>

              <div v-if="!isUserGuest" class="panel-body p-n displayFlex">
                <div class="pull-right socials">
                  <a class="share-icon btn-rounded bg-info" v-bind:href="urlTW" target="_blank">
                    <i class="fa fa-tw"></i>
                  </a>
                  <a class="share-icon btn-rounded bg-primary" v-bind:href="urlFB" target="_blank">
                    <i class="fa fa-fb"></i>
                  </a>
                  <a class="share-icon btn-rounded bg-info" v-bind:href="urlLI" target="_blank">
                    <i class="fa fa-ln"></i>
                  </a>
                </div>
                <div v-if="isOwner" @click="goUpdate" class="pull-right m-l-a">
                  <button class="btn btn-primary-outline btn-primary--font btn-s-sm text-u-c">update</button>
                </div>
                <div v-if="!isOwner" class="pull-left m-l-a">
                  <button
                    @click="goMessage(messageUrl)"
                    class="btn btn-primary-outline btn-primary--font btn-s-sm text-u-c"
                  >message</button>
                </div>
                <div v-if="!isOwner && !following" class="pull-right">
                  <button
                    @click="follow"
                    class="btn btn-primary-outline btn-primary--font btn-s-sm text-u-c m-l-md"
                  >follow</button>
                </div>
                <div v-if="!isOwner && following" class="pull-right">
                  <button
                    @click="unFollow"
                    class="btn btn-primary-outline btn-primary--following btn-primary--font btn-s-sm text-u-c m-l-md"
                  >following</button>
                </div>
              </div>
            </div>

            <!-- HEADER BOTTOM PART - SMALL SCREEN -->
            <div class="hidden-lg hidden-md hidden-sm head__body__bottom--mobile">
              <div class="panel-body p-n displayFlex">
                <div class="socials">
                  <a
                    class="share-icon btn-rounded bg-info m-r-xs"
                    v-bind:href="urlTW"
                    target="_blank"
                  >
                    <i class="fa fa-tw"></i>
                  </a>
                  <a
                    class="share-icon btn-rounded bg-primary m-r-xs"
                    v-bind:href="urlFB"
                    target="_blank"
                  >
                    <i class="fa fa-fb"></i>
                  </a>
                  <a class="share-icon btn-rounded bg-info" v-bind:href="urlLI" target="_blank">
                    <i class="fa fa-ln"></i>
                  </a>
                </div>

                <div v-if="isOwner" @click="goUpdate" class="pull-right m-l-a">
                  <button class="btn btn-primary-outline btn-primary--font text-u-c">update</button>
                </div>
                <div v-if="!isOwner" class="pull-left m-l-a">
                  <button
                    @click="goMessage(messageUrl)"
                    class="btn btn-primary-outline btn-primary--font text-u-c"
                  >message</button>
                </div>
                <div v-if="!isOwner && !following" class="pull-right">
                  <button
                    @click="follow"
                    class="btn btn-primary-outline btn-primary--font text-u-c m-l-sm"
                  >follow</button>
                </div>
                <div v-if="!isOwner && following" class="pull-right">
                  <button
                    @click="unFollow"
                    class="btn btn-primary-outline btn-primary--font text-u-c m-l-sm"
                  >following</button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div class="info_mobile hidden-sm hidden-md hidden-lg">
      <div class="item">
        <span class="profileActiveCount">{{followersCount}}</span>
        <small class="block m-t-n-xs">
          <span class="info_mobile--font">followers</span>
        </small>
      </div>
      <div class="item m-l-md">
        <span class="profileActiveCount">{{articlesCount}}</span>
        <small class="block m-t-n-xs">
          <span class="info_mobile--font">articles</span>
        </small>
      </div>
      <div class="item m-l-md">
        <span class="profileActiveCount">{{eventsCount}}</span>
        <small class="block m-t-n-xs">
          <span class="info_mobile--font">events</span>
        </small>
      </div>
    </div>
  </div>
</template>

<script>
import userNav from './navbar'
import { mapGetters } from 'vuex'
import ApiService from '../../../../services/ApiService'
import LazyImgLoader from '@src/components/lazy-img-loader'

export default {
  name: 'CompanyHeader',
  data() {
    return {
      followersCount: 0,
      articlesCount: 0,
      eventsCount: 0,
      following: false,
      community_id: window.user.community_id,
      messageUrl:
        `${window.user.community_url}/${window.user.community_domain}/chat/addConversation/` +
        this.profile.profile_id,
      marketplaceUrl: window.marketplace.url,
      isOwner: false,
      url: false,
      countryName: null,
      industryName: null,
      isCoverImage: false,
      urlFB: 'http://www.facebook.com/sharer.php?u=',
      urlTW: 'https://twitter.com/share?url=',
      urlLI: 'http://www.linkedin.com/shareArticle?url=',
      apiService: new ApiService(),
    }
  },
  props: {
    profile: null,
  },
  components: {
    userNav,
    LazyImgLoader
  },
  computed: {
    ...mapGetters(['getCountryName', 'getIndustryName']),
    isUserGuest() {
      return typeof window.user.profile_id === 'undefined';
    },
    publicName() {
      return this.profile.corporateProfile.trading_name ?? this.profile.public_identity;
    },
  },
  watch: {
    profile: function (to) {
      this.profile = to
      this.defineUrl()
      this.setCoverImage()
      this.defineOwner()
      this.getFollowersCount()
      this.getArticlesCount()
      this.getEventsCount()
      this.defineCountryName(to.country_id)
      this.defineIndustryName(to.corporateProfile.industry_id)
      this.defineFollow()
    },
  },
  created() {},
  mounted() {
    this.defineUrl()
    this.defineOwner()
    this.setCoverImage()
    this.getFollowersCount()
    this.getArticlesCount()
    this.getEventsCount()
    this.defineCountryName(this.profile.country_id)
    this.defineIndustryName(this.profile.corporateProfile.industry_id)
    this.defineFollow()
  },
  metaInfo() {
    return {
      title: (
        'Corporate - ' +
        this.profile.public_identity +
        ' : ' +
        window.user.community_name
      ).toUpperCase(),
      description: this.profile.about,
      meta: [
        {
          property: 'og:image',
          content: this.profile.public_picture,
        },
        {
          name: 'description',
          content: this.profile.about,
        },
        {
          property: 'og:title',
          content: this.profile.public_identity,
        },
        {
          property: 'og_sitename',
          content: window.user.community_url,
        },
        {
          httpEquiv: 'Content-Type',
          content: 'text/html; charset=utf-8',
        },
        {
          name: 'viewport',
          content: 'width=device-width, initial-scale=1',
        },
      ],
    }
  },
  methods: {
    defineFollow() {
      if (this.profile.profile_id === window.user.profile_id) return
      this.apiService
        .get(
          `/social/is-follow?profile_id=${this.profile.profile_id}&community_id=${window.user.community_id}&follower_profile_id=${window.user.profile_id}`
        )
        .then((res) => {
          this.following = true
        }, (error) => {
          this.following = false
        })
    },
    defineUrl() {
      this.url = encodeURIComponent(
        `${window.user.community_url}/${window.user.community_domain}/default/corporate#/view/` +
          this.profile.profile_id
      )
      this.urlFB += this.url
      this.urlTW += this.url
      this.urlLI += this.url
    },
    goMessage(url) {
      window.location.assign(url)
    },
    defineCountryName(country_id) {
      this.countryName = this.getCountryName(country_id)
    },
    defineIndustryName(industry_id) {
      this.industryName = this.getIndustryName(industry_id)
    },
    follow() {
      this.apiService
        .get(
          `/social/follow?profile_id=${this.profile.profile_id}&community_id=${window.user.community_id}&follower_profile_id=${window.user.profile_id}`
        )
        .then((res) => {
          this.following = true
          this.getFollowersCount()
        })
    },
    getFollowersCount() {
      this.apiService
        .get(
          `/profiles/${this.profile.profile_id}/followers/meta?community_id=${this.community_id}`
        )
        .then((res) => {
          this.followersCount = res.totalCount
        })
    },
    getArticlesCount() {
      this.apiService
        .get(
          `/profiles/${this.profile.profile_id}/articles/meta?community_id=${this.community_id}`
        )
        .then(
          (res) => {
            this.articlesCount = res.totalCount
          },
          (err) => {
            console.log(err)
          }
        )
    },
    getEventsCount() {
      this.apiService
        .get(
          `/profiles/${this.profile.profile_id}/events/meta?community_id=${this.community_id}`
        )
        .then((res) => {
          this.eventsCount = res.totalCount
        })
    },
    unFollow() {
      this.apiService
        .get(
          `/social/un-follow?profile_id=${this.profile.profile_id}&community_id=${this.community_id}&follower_profile_id=${window.user.profile_id}`
        )
        .then((res) => {
          this.following = false
          this.getFollowersCount()
        })
    },
    goUpdate() {
      this.$router.push('../../update/' + this.profile.profile_id)
    },
    defineOwner() {
      this.isOwner = this.profile.profile_id === window.user.profile_id
    },
    setCoverImage() {
      let cover_image = this.profile.cover_image
      if (!cover_image) {
        cover_image =
          'https://ukuyadev.s3.amazonaws.com/system/cover_default.jpg'
      }
      this.$refs.coverImage.style =
        'background: url(' +
        cover_image +
        ') no-repeat;background-size: cover;z-index: 999;width: 100%;'
      var image = new Image()
      image.src = cover_image
      let that = this
      image.onload = function () {
        that.isCoverImage = true
      }
    },
    isShopAvailable() {
      return (
        typeof window.marketplace.apiUrl !== 'undefined' &&
        typeof window.marketplace.store_id !== 'undefined' &&
        typeof window.marketplace.url !== 'undefined'
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.head_small_screen {
  font-family: Roboto;
  letter-spacing: 0.36px;
  color: #000000;
  font-size: 14px;
}
.profile-name {
  display: block;
  margin-left: -3px;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

// .head_small_fonts {
// 	font-size: 10px !important;
// }
.share-icon i {
  margin: 0 auto;
  padding: 0;
  width: 100%;
  margin-left: -3px;
}
.panel-body .textWhite {
  color: #ffffff;
}
.imgSize {
  width: 128px;
  height: 128px;
}
.profileActiveCount {
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 23px;
  color: #ffffff;
}

@media screen and (max-width: 992px) {
  .head__avatar .img-full {
    width: 100px !important;
    height: 90px !important;
  }
}

@media screen and (max-width: 578px) {
  .head__avatar .img-full {
    width: 70px !important;
    height: 66px !important;
  }
  .share-icon i {
    margin: 0 auto;
    padding: 0;
    width: 100%;
    margin-left: -3px;
  }
  .socials .share-icon {
    font-size: 16px;
    height: 20px;
    width: 20px;
    text-align: left;
    line-height: 20px;
  }
}
.preloader {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

@media only screen and (min-width: 1200px) {
  // .head, .head .head__body {
  // 	max-height: 150px;
  // }
  .head__bottom--mobile .displayFlex {
    align-items: center;
  }
  .headerLocation {
    padding-bottom: 5px;
  }
  .nfooter__font {
    font-weight: bold;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    letter-spacing: 0.36px;
    color: #ffffff;
    border-radius: 0px;
  }
  .head_fonts {
    font-weight: 300;
    font-size: 36px;
    line-height: 42px;
    color: #000000;
  }
  .padding-md {
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 5px;
  }
  .head_small_fonts {
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #888888;
  }
  .head_small_fonts .fa-map-marker {
    font-size: 18px;
  }
  .head .head__body .head__body__avatar {
    margin-top: 20px;
    margin-left: 30px;
  }
  .head .head__body .head__body__bottom {
    height: 70px;
    padding: 20px;
    background-color: rgba(0, 0, 0, 0.6);
  }
  .btn-primary-outline {
    background-color: transparent;
    border-color: #fff;
  }
  .btn-primary--following {
    background-color: rgba(255, 255, 255, 0.25);
  }
  .btn-primary-outline:hover {
    background-color: rgba(255, 255, 255, 0.5);
    // opacity: 50%;
    border-color: #fff;
  }
  .btn-primary--font {
    color: #fff;
    font-weight: 300;
    font-size: 14px;
    line-height: 16px;
  }
  // .btn-icon {
  // 	width: 25px;
  // 	height: 25px;
  // }
  .socials {
    // position: absolute;
    // top: -45px;
    // right: 0;
    // margin-right: 20px;
  }
  .socials a {
    margin-right: 0px;
  }
  .socials .btn {
    padding: 5px 10px;
  }
  .socials .share-icon {
    font-size: 16px;
    height: 35px;
    width: 35px;
    text-align: left;
    line-height: 35px;
  }
  // .socials .btn {
  // 	line-height: 1;
  // }
  .m-l-a {
    margin-left: 35px;
  }

  .head .head__body .head__body__industry {
    margin-top: 15px;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #ffffff;
  }
  .padder {
    padding: 0px;
  }
  .wrapper-xs {
    padding: 8px 10px;
  }
  .imgSize {
    width: 128px;
    height: 128px;
  }
  .imgSize img {
    height: 100%;
  }
  .p-n {
    padding: 0px;
  }
  .m-t-xs {
    margin-top: 0px;
  }
  .d-inline-block {
    display: inline-block;
  }
  .displayFlex {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
}

@media only screen and (max-width: 1199px) and (min-width: 768px) {
  // .head, .head .head__body {
  // 	max-height: 150px;
  // }
  .head__bottom--mobile .displayFlex {
    align-items: center;
  }
  .headerLocation {
    margin-left: 15px;
    padding-bottom: 5px;
  }
  .nfooter__font {
    font-weight: bold;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    letter-spacing: 0.36px;
    color: #ffffff;
  }
  .head_fonts {
    font-weight: 300;
    font-size: 36px;
    line-height: 42px;
    color: #000000;
  }
  .padding-md {
    padding-top: 15px;
    padding: 15px;
  }
  .head_small_fonts {
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    letter-spacing: 1px;
    color: #888888;
  }
  .head_small_fonts .fa-map-marker {
    font-size: 20px;
  }
  .head .head__body .head__body__avatar {
    margin-left: 35px;
  }
  .head .head__body .head__body__bottom {
    height: 70px;
    padding: 20px;
    background-color: rgba(0, 0, 0, 0.6);
  }
  .btn-primary-outline {
    // background-color: rgba(0,0,0,0.5);
    background: transparent;
    border-color: #fff;
  }
  .btn-primary--following {
    background-color: rgba(255, 255, 255, 0.25);
  }
  .btn-primary-outline:hover {
    // background-color: #fff;
    // opacity: 50%;
    background-color: rgba(255, 255, 255, 0.5);
    border-color: #fff;
  }
  .btn-primary--font {
    color: #fff;
    font-weight: 300;
    font-size: 14px;
    line-height: 16px;
  }
  // .btn-icon {
  // 	width: 25px;
  // 	height: 25px;
  // }
  .socials {
    position: absolute;
    top: -45px;
    right: 0;
    margin-right: 20px;
  }
  .socials a {
    margin-right: 5px;
  }
  .socials .btn {
    padding: 5px 10px;
  }
  .socials .share-icon {
    font-size: 16px;
    height: 35px;
    width: 35px;
    text-align: left;
    line-height: 35px;
  }
  // .socials .btn {
  // 	line-height: 1;
  // }
  .m-l-a {
    margin-left: auto;
  }

  .head .head__body .head__body__industry {
    margin-top: 40px;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #ffffff;
  }
  .padder {
    padding: 0px;
  }
  .wrapper-xs {
    padding: 8px 10px;
  }
  .imgSize {
    width: 128px;
    height: 128px;
  }
  .imgSize img {
    height: 100%;
  }
  .p-n {
    padding: 0px;
  }
  .m-t-xs {
    margin-top: 0px;
  }
  .d-inline-block {
    display: inline-block;
  }
  .displayFlex {
    display: flex;
    flex-direction: row;
  }
}

@media only screen and (max-width: 767px) {
  .head,
  .head .head__body {
    max-height: 150px;
  }
  .head__bottom--mobile .displayFlex {
    align-items: center;
  }
  .head_fonts {
    font-size: 20px;
    line-height: 23px;
    color: #000000;
  }
  .padding-sm {
    padding-top: 15px;
    padding: 10px;
  }
  .head_small_fonts {
    font-weight: normal;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.666667px;
    color: #888888;
  }
  .head_small_fonts .fa-map-marker {
    font-size: 15px;
  }
  .head .head__body .head__body__avatar {
    margin-left: 15px;
  }
  .head .head__body .head__body__bottom--mobile {
    height: 40px;
    padding: 7px 10px;
    background-color: rgba(0, 0, 0, 0.6);
  }
  .head__body__bottom--mobile .btn-primary-outline {
    width: 75px;
    height: 20px;
    padding: 4px 10px;
  }
  .btn-primary-outline {
    // background-color: rgba(0,0,0,0.5);
    background: transparent;
    border-color: #fff;
  }
  .btn-primary--following {
    background-color: rgba(255, 255, 255, 0.25);
  }
  .btn-primary-outline:hover {
    // background-color: #fff;
    // opacity: 50%;
    background-color: rgba(255, 255, 255, 0.5);
    border-color: #fff;
  }
  .btn-primary--font {
    color: #fff;
    font-weight: 300;
    font-size: 10px;
    line-height: 12px;
  }
  .btn-icon {
    width: 25px;
    height: 25px;
  }
  .socials .btn {
    line-height: 1;
  }
  .m-l-a {
    margin-left: auto;
  }

  .head .head__body .head__body__industry {
    font-weight: normal;
    font-size: 11px;
    line-height: 15px;
    text-align: center;
    color: #ffffff;
  }
  .imgSize {
    width: 80px;
    height: 80px;
  }
  .imgSize img {
    height: 100%;
  }
  .p-n {
    padding: 0px;
  }
  .m-t-xs {
    margin-top: 0px;
  }
  .d-inline-block {
    display: inline-block;
  }
  .displayFlex {
    display: flex;
    flex-direction: row;
  }
  .socials .share-icon {
    font-size: 12px;
    height: 20px !important;
    min-height: 20px;
    max-height: 20px;
    width: 20px !important;
    min-width: 20px;
    max-width: 20px;
    text-align: left;
    line-height: 20px;
  }
  .btn-rounded {
    padding-left: 8px;
    padding-right: 10px;
  }

  .info_mobile {
    display: flex;
    justify-content: center;
    margin-top: 13px;
    margin-bottom: 11px;
    margin-left: 22px;
    margin-right: 22px;
  }
  .profileActiveCount {
    font-size: 14px;
    line-height: 11px;
    color: #000;
  }
  .info_mobile--font {
    font-weight: 300;
    font-size: 10px;
    line-height: 11px;
    color: #000;
  }
}
</style>
